import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppFab from './components/WhatsAppFab';
import CartDrawer from './components/CartDrawer';
import InfoBar from './components/InfoBar';
import Inicio from './pages/Inicio';
import Menu from './pages/Menu';
import Nosotros from './pages/Nosotros';
import Contacto from './pages/Contacto';
import {
  obtenerInformacion,
  obtenerCategorias,
  obtenerProductos,
  obtenerBannersPromo,
  obtenerBannerInfobar,
} from './api';
import type { Informacion, Categoria, Producto, Banner } from './api';

function App() {
  const [info, setInfo] = useState<Informacion | null>(null);
  const [categorias, setCategorias] = useState<Categoria[]>([]);
  const [productos, setProductos] = useState<Producto[]>([]);
  const [promos, setPromos] = useState<Banner[]>([]);
  const [infobar, setInfobar] = useState<Banner | null>(null);

  useEffect(() => {
    obtenerInformacion().then(setInfo);
    obtenerCategorias().then(setCategorias);
    obtenerProductos().then(setProductos);
    obtenerBannersPromo().then(setPromos);
    obtenerBannerInfobar().then(setInfobar);
  }, []);

  const mostrarInfobar = !!infobar?.texto;

  return (
    <CartProvider>
      <BrowserRouter>
        {mostrarInfobar && <InfoBar texto={infobar!.texto!} />}
        <Header info={info} conInfobar={mostrarInfobar} />
        <Routes>
          <Route path="/" element={<Inicio categorias={categorias} productos={productos} info={info} promos={promos} />} />
          <Route path="/menu" element={<Menu categorias={categorias} productos={productos} />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<Contacto info={info} />} />
        </Routes>
        <Footer info={info} />
        <WhatsAppFab info={info} />
        <CartDrawer info={info} />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
